import { useState } from 'react'
import PillSwitcher from './PillSwitcher/PillSwitcher'
import WeeklyShortlist from './WeeklyShortlist/WeeklyShortlist'
import DiscoverView from '../discover/DiscoverView'
import layout from './Home.module.css'

const DashHome = () => {
  const [activeView, setActiveView] = useState('feed')

  return (
    <div className={layout.homeContainer}>
      <PillSwitcher activeView={activeView} onViewChange={setActiveView} />

      {activeView === 'feed' && (
        <div className={layout.discoverWrapper}>
          <DiscoverView />
        </div>
      )}

      {activeView === 'shortlist' && (
        <div className={layout.shortlistView}>
          <WeeklyShortlist />
        </div>
      )}
    </div>
  )
}

export default DashHome
